import {
    madnes_add_group,
    madnes_add_img, madnes_add_to_group,
    madnes_key_exist, madnes_set_alpha, madnes_set_img_center,
    madnes_set_pos, madnes_set_scale,
    madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {
    madnes_add_bitmap_float,
    madnes_add_bitmap_text, madnes_add_text,
    madnes_set_bitmap_float
} from "../framework/src/engine/madnes/madnes_text";
import {QueueProcessor} from "./queue_processor";
import {bet, madnes_get_json} from "../framework/src/engine/madnes/madnes";
import {server_config, picture_convert, quality, server_result, wi} from "../framework/src/engine/madnes/madnes_variables";
import {madnes_move_to} from "../framework/src/engine/madnes/madnes_render";
import {AnimBlink, AnimFade} from "./turbo27_extanims";

var menu_objects = new Array();
var info_pos = 0;

var info_pos_count = 3;

var leftLabelX = 162;
var rightLabelY = 699;
var leftScale = 0.6;
var rightScale = 0.48;

var slides = {

    1: {
        'symbol_Joker': { 'bgX': leftLabelX, 'bgY': 147, 'symX': leftLabelX + 60, 'symY': 146 + 12, 'txtY': 228, 'bgType': "big", 'symScale': leftScale, 'winX': 540, 'winY': 188 },
        'symbol_Bar': { 'bgX': leftLabelX, 'bgY': 279, 'symX': leftLabelX + 60, 'symY': 279 + 12, 'txtY': 358, 'bgType': "big", 'symScale': leftScale, 'winX': 540, 'winY': 318 },
        'symbol_Seven': { 'bgX': leftLabelX, 'bgY': 411, 'symX': leftLabelX + 60, 'symY': 412 + 12, 'txtY': 492, 'bgType': "big", 'symScale': leftScale, 'winX': 540, 'winY': 452 },
        'symbol_Grape': { 'bgX': leftLabelX, 'bgY': 543, 'symX': leftLabelX + 60, 'symY': 545 + 12, 'txtY': 625, 'bgType': "big", 'symScale': leftScale, 'winX': 540, 'winY': 585 },
        'symbol_Bell': { 'bgX': rightLabelY, 'bgY': 146, 'symX': rightLabelY + 60, 'symY': 146 + 12, 'txtY': 214, 'bgType': "small", 'symScale': rightScale, 'winX': 1078, 'winY': 174 },
        'symbol_Plum': { 'bgX': rightLabelY, 'bgY': 253, 'symX': rightLabelY + 60, 'symY': 253 + 12, 'txtY': 320, 'bgType': "small", 'symScale': rightScale, 'winX': 1078, 'winY': 280 },
        'symbol_Orange': { 'bgX': rightLabelY, 'bgY': 358, 'symX': rightLabelY + 60, 'symY': 358 + 12, 'txtY': 426, 'bgType': "small", 'symScale': rightScale, 'winX': 1078, 'winY': 386 },
        'symbol_Cherry': { 'bgX': rightLabelY, 'bgY': 463, 'symX': rightLabelY + 60, 'symY': 463 + 12, 'txtY': 532, 'bgType': "small", 'symScale': rightScale, 'winX': 1078, 'winY': 488 },
        'symbol_Dollar': { 'bgX': rightLabelY, 'bgY': 568, 'symX': rightLabelY + 60, 'symY': 568 + 12, 'txtY': 636, 'bgType': "small", 'symScale': rightScale, 'winX': 1078, 'winY': 596 },
    }
};

export function t27_infomenu_init()
{
    for(var slideIdx in slides)
    {
        madnes_add_group("wintable_group_" + slideIdx);
        madnes_add_img("wintable_" + slideIdx, "wintable_" + slideIdx, 0, 0);
        madnes_add_to_group("wintable_group_" + slideIdx, "wintable_" + slideIdx);
        madnes_set_pos("wintable_group_" + slideIdx, -9999, -9999);
        madnes_set_visible("wintable_group_" + slideIdx, false);

        for(var symbol in slides[slideIdx]) {
            var symb = slides[slideIdx][symbol];

            madnes_add_img("wt_bg_" + symbol, "wintable_label_bg_" + symb['bgType'], symb['bgX'], symb['bgY']);
            madnes_set_visible("wt_bg_" + symbol, false);
            madnes_add_to_group("wintable_group_" + slideIdx, "wt_bg_" + symbol);

            madnes_add_img("wt_" + symbol, symbol, symb['symX'], symb['symY'] );
            madnes_set_scale("wt_" + symbol, symb['symScale'], symb['symScale']);
            madnes_add_to_group("wintable_group_" + slideIdx, "wt_" + symbol);

            madnes_add_bitmap_text("wt_text_3" + symbol, "font_wintable", symb['bgX'] + 20, symb['txtY'], "3", 80);
            madnes_set_img_center("wt_text_3" + symbol, 0, 1);
            madnes_add_to_group("wintable_group_" + slideIdx, "wt_text_3" + symbol);

            madnes_add_bitmap_text("wt_text_x" + symbol, "font_wintable", symb['bgX'] + 40, symb['txtY'], "X", 60);
            madnes_set_img_center("wt_text_x" + symbol, 0, 1);
            madnes_add_to_group("wintable_group_" + slideIdx, "wt_text_x" + symbol);

            madnes_add_bitmap_float("wt_win_" + symbol, "font_wintable", symb['winX'], symb['winY'], "", 80, 190);

            madnes_set_img_center("wt_win_" + symbol, 1, 0.5);
            madnes_add_to_group("wintable_group_" + slideIdx, "wt_win_" + symbol);
        }
    }


    madnes_add_group("wintable_group_" + 2);
    madnes_add_img("wintable_" + 2, "wintable_" + 2, 0, 0);
    madnes_add_to_group("wintable_group_" + 2, "wintable_" + 2);
    madnes_set_pos("wintable_group_" + 2, 0, 0);
    madnes_set_visible("wintable_group_" + 2, false);

    madnes_add_img("wt_bonus_x2", "wt_bonus_x2", wi / 2, 600, 1, 0.5, 0.5);
    madnes_set_visible("wt_bonus_x2", false);
    madnes_add_to_group("wintable_group_" + 2, "wt_bonus_x2");

    madnes_add_img("wt_bonus_fs", "wt_bonus_fs", wi / 2, 600, 1, 0.5, 0.5);
    madnes_set_visible("wt_bonus_fs", false);
    madnes_add_to_group("wintable_group_" + 2, "wt_bonus_fs");


    madnes_add_group("wintable_group_3");
    madnes_add_img("infopage_3", "infopage_3", 0, 0);
    madnes_add_to_group("wintable_group_3", "infopage_3");
    madnes_set_pos("wintable_group_3", -9999, -9999);
    madnes_set_visible("wintable_group_3", false);

    //madnes_add_bitmap_text("wtf", "font_wintable", 100, 200, "123456789 abcdefghijklmnopqr", 80);

    madnes_add_img("wt_logo", "label", wi / 2 - 60, 6);
    madnes_set_img_center("wt_logo", 0.5, 0);
    madnes_set_visible("wt_logo", false);

    var infotext = madnes_get_json("infotext");

    for(var i in infotext)
    {
        var x = infotext[i]["position"][0];
        var y = infotext[i]["position"][1];

        if(infotext[i]["lqShiftX"] && quality === 50) {
            x += infotext[i]["lqShiftX"];
        }

        var page = infotext[i]["page"];
        var lineHeight0 = infotext[i]['title'] ? infotext[i]['title']["lineHeight"] : 0;
        var lineHeight1 = infotext[i]["lineHeight"];

        var style0 = {
            "font": "30px Arial",
            "fill": "#e595ff",
            "fontWeight": "",
        };
        var style1 = {
            "font": "30px Arial",
            "fill": "#ffffff",
            "fontWeight": "",
        };

        if(infotext[i]["fontSize"] && infotext[i]["font"]) {
            style0["font"] = infotext[i]["fontSize"] + "px " + infotext[i]["font"];
            style1["font"] = infotext[i]["fontSize"] + "px " + infotext[i]["font"];
        }

        if(infotext[i]["title"] && infotext[i]["title"]["color"]) {
            style0["fill"] = infotext[i]["title"]["color"];
        }

        if(infotext[i]["body"] && infotext[i]["body"]["color"]) {
            style1["fill"] = infotext[i]["body"]["color"];
        }

        if(infotext[i]["title"] && infotext[i]["title"]["bold"]) {
            style0["fontWeight"] = "bold";
        }

        if(infotext[i]["body"] && infotext[i]["body"]["bold"]) {
            style1["fontWeight"] = "bold";
        }

        var line0 = 0;
        var line1 = 0;

        if(infotext[i]["title"]) {
            for(var j in infotext[i]["title"]["content"])
            {
                var text = infotext[i]["title"]["content"][j].toUpperCase();
                var textName = "info_header_" + i + "_"  + j + "_" + line0;
                var groupName = "wintable_group_" + ( page * 1 + 2 );

                madnes_add_text(textName, x, y + line0 * lineHeight0, text, style0);
                madnes_add_to_group(groupName, textName);
                line0++;
            }
        }

        if(infotext[i]["body"]) {
            for(var j in infotext[i]["body"]["content"])
            {
                var text = infotext[i]["body"]["content"][j];
                var textName = "info_body_" + i + "_"  + j + "_" + line1;
                var groupName = "wintable_group_" + ( page * 1 + 2 );

                madnes_add_text(textName, x, y + line0 * lineHeight0 + line1 * lineHeight1, text, style1);
                madnes_add_to_group(groupName, textName);
                line1++;
            }
        }


    }

    /*madnes_add_graphics("test", 540, 190);
    madnes_graphics_set_line_style("test", 1, 0xFF0000);
    //madnes_graphics_begin_fill("test", 0xFF700B);
    madnes_graphics_draw_rectangle("test", 0, 0, -160, 50);
    madnes_add_to_group("wintable_group_1", "test");*/

    t27_infomenu_update();
}


function set_info_sums()
{
    for(var symIndex in server_config.logic.symbols) {
        var factors = server_config.logic.symbols[symIndex]['factors'];
        var symbName = server_config.logic.symbols[symIndex]['name'];

        if(madnes_key_exist("wt_win_" + symbName)) {
            madnes_set_bitmap_float("wt_win_" + symbName, bet * factors[2], 190);
        }
    }
}

export var openinfo = false;
export function t27_infomenu_open()
{
    madnes_set_visible("wintable_group_" + (info_pos + 1), true);
    madnes_set_pos("wintable_group_" + (info_pos + 1), 0, 0);

    madnes_set_visible("wt_logo", true);

    wt_anims_prepare(info_pos);
    wt_anims_run(info_pos);

    openinfo = true;
}

export function t27_infomenu_close()
{
    madnes_set_visible("wt_logo", false);

    for(var i = 1; i <= info_pos_count; i++)
    {
        madnes_set_visible("wintable_group_" + i, false);
        madnes_set_pos("wintable_group_" + i, -9999, -9999);
    }

    wt_stop_all_anims();

    openinfo = false;
}

// function infomenu_click()
// {
// 	//madnes_audio_play("bet");
// 	infomenu_update();
// }

export function t27_infomenu_update()
{
    setTimeout(function() {
        set_info_sums();
    }, 100);

}

export function t27_infomenu_left()
{
    if(!openinfo) return;
    menu_swipe(-1);
}

export function t27_infomenu_right()
{
    if(!openinfo) return;
    menu_swipe(1);
}

var wt_swipe_lock = false;

function menu_swipe(dir)
{
    if(wt_swipe_lock) {
        return false;
    }

    var info_pos_new = info_pos + dir;

    if(info_pos_new > info_pos_count - 1) {
        info_pos_new = 0;
    }

    if(info_pos_new < 0) {
        info_pos_new = info_pos_count - 1;
    }

    madnes_move_to("wintable_group_" + (info_pos + 1), wi * dir * -1, null, 250);

    madnes_set_pos("wintable_group_" + (info_pos_new + 1), wi * dir, 0);

    wt_swipe_lock = true;

    (function(info_pos_new) {
        wt_anims_prepare(info_pos_new);
        wt_stop_all_anims();

        madnes_move_to("wintable_group_" + (info_pos_new + 1), 0, null, 250, function() {
            wt_swipe_lock = false;
            wt_anims_run(info_pos_new);
        });
    }(info_pos_new));

    madnes_set_visible("wintable_group_" + (info_pos_new + 1), true);

    info_pos = info_pos_new;
}

var wtAnimQueue = new QueueProcessor();

var wt_anims = {
    0: {
        'stopped': true,
        'anims': {
            'blink': null,
        }
    },
    1: {
        'stopped': true,
        'anims': {
            'fade': null,
        }
    }
};

function wt_stop_all_anims()
{
    for(var i in wt_anims) {
        wt_anims_stop(i);
    }

    wtAnimQueue.clear();
}

function wt_anims_stop(slideId)
{
    wtAnimQueue.stop();

    wt_anims[slideId]['stopped'] = true;
    for(var i in wt_anims[slideId]['anims']) {
        if(wt_anims[slideId]['anims'][i] !== null) {
            wt_anims[slideId]['anims'][i].stop();
        }

        wt_anims[slideId]['anims'][i] = null;
    }
}

function wt_anims_prepare(slideId)
{
    switch(slideId) {
        case 0:
            for(var symbol in slides[1]) {
                madnes_set_visible("wt_bg_" + symbol, false);
            }
            break;
        case 1:
            madnes_set_alpha("wt_bonus_fs", 0);
            madnes_set_visible("wt_bonus_fs", true);
            madnes_set_alpha("wt_bonus_x2", 0);
            madnes_set_visible("wt_bonus_x2", true);
            break;
    }
}

function wt_anims_run(slideId)
{
    wt_stop_all_anims();


    switch(slideId) {
        case 0:
            wt_anims[slideId]['stopped'] = false;
            anim_win_frames();
            break;
        case 1:
            wt_anims[slideId]['stopped'] = false;
            anim_slide2();
            break;
    }
}


function anim_win_frames() {

    wtAnimQueue.stop();
    wtAnimQueue.clear();

    if(!server_result || !server_result.result || typeof server_result.result.lineWins == 'undefined' || wt_anims[0]['stopped']) {
        return;
    }

    for(var lwIdx in server_result.result.lineWins) {
        wtAnimQueue.add(anim_win_frame.bind(this, server_result.result.lineWins[lwIdx]));
    }

    wtAnimQueue.run().then(function() {
        anim_win_frames();
    });
}

function anim_win_frame(lineWin)
{
    return new Promise(function(resolve) {

        if(wt_anims[0]['stopped']) {
            resolve(); //skip anis in queue
        }

        var symbolName = picture_convert[lineWin['symbol']];        
        wt_anims[0]['anims']['blink'] = new AnimBlink("wt_bg_" + symbolName, 1, 2000);
        try{
            wt_anims[0]['anims']['blink'].run().then(resolve);
        } catch(e) {
            //unknow bug (hot fix)
            // console.log(e);
        }

    });
}

function anim_bonus(type)
{
    return new Promise(function(resolve) {

        wt_anims[1]['anims']['fade'] = new AnimFade("in", "wt_bonus_" + type, 220);

        madnes_set_visible("wt_bonus_" + type, true);
        madnes_set_alpha("wt_bonus_" + type, 0);

        wt_anims[1]['anims']['fade'].run().then(function() {

            wt_anims[1]['anims']['fade'] = new AnimFade("out", "wt_bonus_" + type, 220, 2600);
            wt_anims[1]['anims']['fade'].run().then(function() {
                resolve();
            });
        });
    });
}

function anim_slide2()
{
    wtAnimQueue.stop();
    wtAnimQueue.clear();

    if(wt_anims[1]['stopped']) {
        return;
    }

    wtAnimQueue.add(anim_bonus.bind(this, "fs"));
    wtAnimQueue.add(anim_bonus.bind(this, "x2"));

    wtAnimQueue.run().then(anim_slide2);
}